// Токен хранится в localStorage между перезагрузками страницы; сид-фраза и PIN — никогда.
const TOKEN_KEY = 'extasy.auth.token'

export function readToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

export function writeToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken(): void {
  localStorage.removeItem(TOKEN_KEY)
}

/** UUID учётной записи из сохранённого токена (поле sub); токена нет или он не читается — пустая строка */
export function readTokenUserUuid(): string {
  const payload = (readToken() ?? '').split('.')[1]
  if (!payload) {
    return ''
  }
  try {
    const claims = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')))

    return typeof claims.sub === 'string' ? claims.sub : ''
  } catch {
    return ''
  }
}
